var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownIconGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.571 5.35514L12.521 0.405142C12.6132 0.309632 12.7236 0.233449 12.8456 0.18104C12.9676 0.128631 13.0988 0.101045 13.2316 0.0998913C13.3644 0.0987375 13.4961 0.124039 13.619 0.17432C13.7418 0.224601 13.8535 0.298854 13.9474 0.392747C14.0413 0.486639 14.1155 0.598291 14.1658 0.721188C14.2161 0.844084 14.2414 0.975764 14.2402 1.10854C14.2391 1.24132 14.2115 1.37254 14.1591 1.49455C14.1067 1.61655 14.0305 1.72689 13.935 1.81914L8.278 7.47614C8.09047 7.66361 7.83616 7.76893 7.571 7.76893C7.30583 7.76893 7.05153 7.66361 6.864 7.47614L1.207 1.81914C1.11149 1.72689 1.03531 1.61655 0.982897 1.49455C0.930488 1.37254 0.902902 1.24132 0.901748 1.10854C0.900594 0.975764 0.925896 0.844084 0.976177 0.721188C1.02646 0.598291 1.10071 0.486639 1.1946 0.392747C1.2885 0.298854 1.40015 0.224601 1.52304 0.17432C1.64594 0.124039 1.77762 0.0987375 1.9104 0.0998913C2.04318 0.101045 2.1744 0.128631 2.2964 0.18104C2.41841 0.233449 2.52875 0.309632 2.621 0.405142L7.571 5.35514Z",
    fill: "#697077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIconGray);
export default __webpack_public_path__ + "static/media/dropdown-icon-gray.351b86d6f225ce4c99a8ca9267666573.svg";
export { ForwardRef as ReactComponent };